<template>
    <div>
        <v-card-text v-if="loading" text-center>
            <v-progress-circular
            indeterminate
            size="64"
            width="7"
            color="primary"
            ></v-progress-circular>
        </v-card-text>
        <v-container class="ma-0 pa-0" v-else>

            <v-row no-gutters>
                <v-col cols="12">
                    <v-tabs v-model="tab">
                        <v-tab
                            key="'selection'">
                            scelta strumenti
                        </v-tab>
                        <v-tab
                            key="'selected'">
                            strumenti selezionati
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item key="'selection'">
                            <v-container class="pa-2 pa-0 ma-0">
                                <div v-if="advanced_search">
                                <v-divider />
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                                        <span class="text-h6">Ricerca avanzata</span>
                                        <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <!-- <v-col cols="6" class="d-flex justify-start align-content-center">
                                        <v-autocomplete dense outlined
                                            label="famiglia"
                                            v-model="filter.search_family"
                                            :items="Object.keys(families)"
                                            multiple
                                            clearable></v-autocomplete>
                                    </v-col> -->
                                    <v-col cols="6" class="d-flex justify-start align-content-center pl-2">
                                        <v-text-field dense outlined
                                            label="seriale/marca/modello"
                                            v-model="filter.search"
                                            clearable></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex justify-center align-content-center">
                                        <v-btn color="primary" class="text-center" @click="search"><v-icon class="ma-2">search</v-icon>cerca</v-btn>
                                        <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                                    </v-col>
                                </v-row>
                                </div>
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex flex-row justify-end align-content-center mt-4">
                                        <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                                    </v-col>
                                </v-row>
                
                                <!------------------------------------------------------------------>
                                <v-row no-gutters v-for="instr in objects" :key="instr._id">
                                    <OpInstrumentItem
                                        :instrument_id="instr._id"
                                        :show_platform_capacity="true"
                                        :key="instr._id">
                                        <template v-slot:item_action>
                                            <v-checkbox 
                                                class="ma-0" 
                                                hide-details 
                                                :value="instr._id" 
                                                :disabled="locked_instr.includes(instr._id)"
                                                v-model="instrument_ids">
                                            </v-checkbox>
                                        </template>
                                    </OpInstrumentItem>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item key="'selected'">
                            <v-container class="pa-0 ma-0">
                                <v-row no-gutters v-for="instr_id in instrument_ids" :key="instr_id">
                                    <OpInstrumentItem
                                        :instrument_id="instr_id"
                                        :show_platform_capacity="true"
                                        :key="instr_id">
                                        <template v-slot:item_action>
                                            <v-btn 
                                                :disabled="locked_instr.includes(instr_id)"
                                                fab
                                                small
                                                color="action"
                                                class="ma-2" 
                                                @click="removeInstrumentFromSelection(instr_id)">
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </OpInstrumentItem>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
// import _ from 'lodash'

import {ListManagement} from "../../utils/listMixin"
import OpInstrumentItem from "./OpInstrumentItem"
import { searchDesign } from "../../utils/dbUtility"
import { p_families } from "../../utils/common"


export default {
    components: {OpInstrumentItem},
    mixins: [ListManagement],
    props: {
        client_id: {
            type: String,
            required: true
        },
        show_platform_capacity: {
            type: Boolean,
            required: false,
            default: false
        },
        selected_instruments: {
            type: Array,
            required: false,
            default: null
        },
        lock_inst_reports: {
            type: Boolean,
            required: false,
            default: false
        },
        operation_id: {
            type: String,
            required: false,
            default: null
        },
        o_all_instrument: {
            type: Boolean,
            required: false,
            default: false
        },
        op_type: {
            type: String,
            required: false,
            default: null
        }
    },
    data(){
        return {
            families: p_families,
            tab: 'selection',
            db: 'registry',
            o_selector: {doc_type:'instrument', dismissed: false, visible: true},
            selector: {},
            fields: ['_id', 'metro_data.iso.next_operation','metro_data.lat.next_operation','metro_data.leg.next_operation','metro_data.iso_simple.next_operation', 'client_id', 'location_id', 'deparment_id', 'family', '_rev'],
            department_ids: [],
            instrument_ids:[],
            instruments: [],
            all_instrument: false,
            client: {},
            location: {},
            locations: [],
            loading: true,
            sort_fields: {label: 'scadenza', value: ['value.exp', 'value.name'], order: ['asc', 'asc']},
            sort_asc: false,
            locked_instr: [],
            filter: {
                client_id: this.client_id,
                location_id: this.location_id,
                department_id: null,
                search_family: [],
                search: ""
            },
            filtered_search: false,
            sorting_fields: [
                {label: 'scadenza', value: ['value.exp', 'value.name', 'value.serno'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name', 'value.serno'], order: ['desc', 'asc']},
                {label: 'nome/codice cliente', value: ['value.name', 'value.serno', 'value.exp'], order: ['asc', 'asc']},
                {label: 'seriale', value: ['value.serno', 'value.name', 'value.exp'], order: ['asc', 'asc']},
                {label: 'famiglia', value: ['value.family', 'value.exp', 'value.name'], order: ['asc', 'asc']}
            ],
            list_type: 'instrument'
        }
    },
    computed: {
        
    },
    async mounted() {
        this.loading = true
        if(this.selected_instruments) {
            this.instrument_ids = [...this.selected_instruments]
        }
        this.all_instrument = this.o_all_instrument
        await this.updateSearch()
        if (this.lock_inst_reports && this.operation_id) {
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'all_keys', [['operation', this.operation_id], ['client', this.client_id]], false)
            this.locked_instr = _.map(res, function(doc) {
                console.log(doc.value.instrument_id)
                return doc.value.instrument_id
            });
        }
        this.loading = false
    },
    methods: {
        async updateSearch() {
            this.searching = true
            var selectors = ['primary']
            if (this.filter.search_family){
                selectors.push(['family', 'bilancia nawi'])
            }
            let res = await this.searchFromDesignNew('primary/searchByData', 'all_keys', selectors, false)
            if (this.filter.search) {
                let text_res = await this.searchFromDesignNew('primary/searchByText', 'text', this.filter.search, false)
                let items = _.intersectionWith(res, text_res, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
                
                this.objects = this.orderBy(items, this.sort_fields)
            } else {
                this.objects = this.orderBy(res, this.sort_fields)
            }
            this.searching = false
        },
        resetSearch(){
            this.filter = {
                client_id: this.client_id,
                location_id: null,
                department_id: null,
                search_family: [],
                search: ""
            }
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null})
        },
        getData() {
            return {comparator_ids: this.instrument_ids}
        },
        removeInstrumentFromSelection(instr_id) {
            let idx = this.instrument_ids.indexOf(instr_id)
            this.instrument_ids.splice(idx, 1)
            console.log('REMOVE FROM SELECTION', instr_id)
        },
    },
    
}

</script>